const CARDS_TO_SHOW_SMALL = 2.0;
const CARDS_TO_SHOW_MEDIUM = 3.2;
const CARDS_TO_SHOW_LARGE = 3.5;

export const calculateCardsToShow = (width: number) => {
	if (width < 480) {
		return CARDS_TO_SHOW_SMALL;
	}
	if (width < 720) {
		return CARDS_TO_SHOW_MEDIUM;
	}
	return CARDS_TO_SHOW_LARGE;
};
